import { createRoot } from 'react-dom/client';
import { BackColor } from "Interfaces/general.interface";
import ComponentImage from 'GeneralComponents/ComponentImage';
import './TitleComponent.min.css';
import Helper from "Interfaces/Helper";
import ComponentBackground from 'GeneralComponents/ComponentBackground';
import useImageHeight from './useImageHeight';

const TEXT_WEIGHTS = { BOLD: 'Bold', MEDIUM: 'Medium' };
const UMB_TEXT_WEIGHT = { BOLD: ['בולד', 'מודגש'], MEDIUM: ['מדיום', 'בינוני'] };

function getBackgroundColor(backColor: string, hasPalleteTextColor: boolean): BackColor {

    // Default color
    const lightColor = "#FFFFFF";

    const lightBG: BackColor = {
        Color: {
            id: 1,
            label: lightColor,
            value: lightColor
        },
        Type: "light"
    };

    // Defualt light-bg when text-color is set to pallete-color
    if (backColor && !hasPalleteTextColor) return JSON.parse(backColor);
    return lightBG;
}

interface Props {
    currentPageId: string;
    componentId: string;
    title: string;
    description: string;
    textWeight: string;
    alignTextToRL: boolean; 
    hasPalleteTextColor: boolean;
    changeImagePosition: boolean;
    backColor: string; // BackColor;
    backgroundImage: string; // MediaItem;
    mobileBackgroundImage: string; //  MediaItem;
}


const TitleComponent: React.FC<Props> = (props) => {

    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const isMobile = !isDesktop;
    const { title, description, alignTextToRL, hasPalleteTextColor, textWeight, changeImagePosition, backgroundImage, mobileBackgroundImage, backColor } = props;
    const defaultTextWeight = TEXT_WEIGHTS.MEDIUM;
    const isBold = UMB_TEXT_WEIGHT.BOLD.some(weight => textWeight == weight);
    const fontWeight = (isBold ? TEXT_WEIGHTS.BOLD : defaultTextWeight).toLowerCase();
    const desktopImage = Helper.convertServerMediaItemToMediaItem(backgroundImage);
    const mobileImage = Helper.convertServerMediaItemToMediaItem(mobileBackgroundImage);
    const hasImage: boolean = !!desktopImage.url;
    const colorBG: BackColor = getBackgroundColor(backColor, hasPalleteTextColor);
    const textColor = colorBG.Type === "dark" ? 'light' : 'dark';
    const isTextAlignedToSide = (isDesktop && (hasImage || !!alignTextToRL)) || (isMobile && !!alignTextToRL);
    const contentPosition = isTextAlignedToSide ? 'start' : 'center';

    // Set image height to match content height
    const { titleContentRef, titleInnerContainerRef } = useImageHeight(isDesktop);

    return <div
        id={"mst-title-component-" + props.componentId}
        className={`mst-title-component ${hasImage ? 'container-fluid with-img' : 'container mx-auto'} ${!title && !description ? "d-none" : "pt-3 pb-3"}`}>

        <ComponentBackground
            componentId={"TitleComponent-" + props.componentId}
            backGround={colorBG}
            setLightBg={null}>

            <div ref={titleInnerContainerRef} className="row title-inner-container">

                {
                    hasImage &&

                    <>
                        <ComponentImage
                            wrapperDivClass={`
                                col-12 col-lg-4 p-0 h-100 m-0 
                                order-lg-${changeImagePosition ? '1' : '3'} 
                                d-flex align-items-top justify-content-${changeImagePosition ? 'start' : 'end'} 
                            `}
                            imageClass={"mst-titleLine-img bg-img"}
                            mobileImageClass={"mst-titleLine-img w-100 sm-bg-img"}
                            image={desktopImage}
                            mobileImage={mobileImage}
                        />

                        {/* Dummy spacing before text */}
                        <div className={`d-none d-lg-block dummy-space-el order-lg-${changeImagePosition ? '3' : '1'}`} />

                    </>
                }

                <div className={`title-content
                    col-12 col-lg d-lg-flex d-block order-lg-2
                    justify-content-${contentPosition}
                    text-${contentPosition}
                    ${hasImage? (changeImagePosition ? 'padding-start-88' : 'padding-end-88'): ''}
                    ${hasPalleteTextColor ? 'txt-pallete-color' : `title-txt-${textColor}`}`}>

                    <div ref={titleContentRef}>

                        {title && 
                            <h2 className={`mx-auto mx-md-0 assistant-${fontWeight}`}>{title}</h2>
                        }
                        {description &&
                            <p className="mst-titleLine-desc-txt">{description}</p>
                        }

                    </div>

                </div>

            </div>

        </ComponentBackground>

    </div>
}


var elements = document.querySelectorAll('[id^="TitleComponent-"]');
for (var i = 0; i < elements.length; i++) {
    var rootElement = document.getElementById(elements[i].id);
    var root = createRoot(rootElement);

    root.render(
        <TitleComponent
            title={rootElement.getAttribute('component-title')}
            description={rootElement.getAttribute('component-description')}
            currentPageId={rootElement.getAttribute('component-currentPageId')}
            componentId={rootElement.getAttribute('component-id')}
            alignTextToRL={!!rootElement.getAttribute('component-alignTextToRL')}
            textWeight={rootElement.getAttribute('component-textWeight')}
            backColor={rootElement.getAttribute('component-backColor')}
            hasPalleteTextColor={!!rootElement.getAttribute('component-palleteColorText')}
            backgroundImage={rootElement.getAttribute('component-backgroundImage')}
            mobileBackgroundImage={rootElement.getAttribute('component-mobileBackgroundImage')}
            changeImagePosition={!!rootElement.getAttribute('component-changeImagePosition')}
        />)
}